module.exports = __webpack_public_path__ + "img/seleccion-multiple.11a8ae29.svg";